import { cn } from "@/lib/utils";

export const Mascot = ({ pose = "empty", className, size = 160 }) => (
  <img
    src={`/mascots/${pose}.jpg`}
    alt=""
    width={size}
    height={size}
    className={cn("rounded-3xl object-cover mix-blend-multiply", className)}
    style={{ width: size, height: size }}
    data-testid={`mascot-${pose}`}
  />
);

export const EmptyState = ({ title, text, action, pose = "empty", testId }) => (
  <div data-testid={testId} className="flex flex-col items-center text-center py-10 px-6 rise">
    <Mascot pose={pose} size={140} />
    <h3 className="serif text-2xl mt-4 text-[var(--coffee)]">{title}</h3>
    {text && <p className="text-sm text-[var(--coffee-muted)] mt-2 max-w-xs leading-relaxed">{text}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
